import React, { Component } from 'react'

import style from './style.css'
export default class Masonry extends Component {
    state = {
        collums: 2
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            if(document.documentElement.offsetWidth > 641) {
                if(this.state.collums === 2) return
                this.setState({
                    collums: 2
                })
            } else {
                if(this.state.collums === 1) return
                this.setState({
                    collums: 1
                })
            }
        })	
    }
    render() {
        let collums = this.state.collums

        let data = this.props.children

        this.masonry = []
        let curse = 0
        collums--
        for (var i = 0; i < data.length; i++) {
            var item = data[i]
            if(!this.masonry[curse]) this.masonry[curse] = []
            this.masonry[curse].push(item)
            curse++
            if(curse > collums) curse = 0
        }


        return (
            <div className={style.box}>

                {this.masonry.map((col, key) => (
                    <div key={key} className={style.col} style={{ width: `${100 / this.state.collums}%`}}>
                       {col.map((item, k) => (
                           <div className={style.item} key={k}>{item}</div>
                       ))}
                    </div>
                ))}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Masonry/index.js